<template>
  <div class="navigation-error">
    <SpinnerLoader v-if="isRedirecting" :size="48" />
    <ActionableHelperView v-else :on-retry="redirectToPreviousPage" />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import {
  ActionableHelperView,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    ActionableHelperView,
    SpinnerLoader
  }
})
export default class NavigationErrorView extends Vue {
  isRedirecting = false;

  private get previousRoute() {
    return this.$route.query.previousRoute as string;
  }

  private resetIsRedirectingFlag() {
    this.isRedirecting = false;
  }

  redirectToPreviousPage() {
    this.isRedirecting = true;
    this.$router.replace(
      { path: this.previousRoute },
      this.resetIsRedirectingFlag,
      this.resetIsRedirectingFlag
    );
  }
}
</script>

<style lang="less" scoped>
.navigation-error {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
